import {setActive} from './active';

export function handlerPagination(selector) {
	return function handlerInner() {
		const items = this.selector.querySelectorAll(`.${selector}`);
		setActive(items, this.currentSlide, this.perPage);
	};
}
